import $ from 'jquery';
import { initMobileMenu } from './mobile-menu';
import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';

import { initCleaveDate } from './cleave-date';
//import { initTMIdentity } from './tm-login';

//import 'slick-carousel';
import {mobileMasker} from './mobile-masker';
import {autocomplete} from './autocomplete';
import { initSliderPro } from './slider-pro';
import { initDiscography } from './discography';

import { dropDownMenu } from "./component/dropdownMenu";
import { prepareMiniLightBox } from "./component/mini-lightbox/mini-lightbox-configure";

// Import magnificPopup
import { initMagnificPopup } from './magnific-popup';

const polyfillStartWith = () => {
	if(!String.prototype.startsWith) {
		String.prototype.startsWith = function(searchString, position){
			return this.substr(position || 0, searchString.length) === searchString;
		};
	}
}

$(function () {
	polyfillStartWith();

	initMobileMenu();
	paintMasonryLayout();
	initFancyInputBox();
	initInfiniteScroll();
	initStateDropDownBox();
	formValidationEvents();
	sizePicker();

	//initTMIdentity();
	initCleaveDate();
	mobileMasker();
	autocomplete();
	prepareMiniLightBox();
	initSliderPro();
	initDiscography();
	dropDownMenu();

	initMagnificPopup();
});

